import styled from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const LoadingContainer = styled.div`
  padding: 24px;
  background-color: #ffffff;
`;

export const ErrorContainer = styled.div`
  padding: 24px;
  background-color: #ffffff;
`;

export const DashboardContainer = styled.div<{ isVisible: boolean }>`
  flex: 1;
  width: 100%;
  background-color: #f8f9fa;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;
